import { parseInsightRule } from 'containers/insights'
import { stringifyQuery } from './hooks/use-query-params'

export const getEventUrl = (event, routes) => {
  if (event.type === 'alarm') return { pathname: routes.alarms.alarm.url({ alarmId: event.rule }), search: stringifyQuery({ selected: event.id }) }
  if (event.type === 'insight') return { pathname: routes.insights.rule.url({ ruleId: parseInsightRule(event.rule) }), search: stringifyQuery({ selected: event.id }) }
  return routes.errors.error.url({ errorId: event.id })
}
